module.exports = __webpack_public_path__ + "static/media/Grupo10mg.3142f9c0.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/img-on-satelital/Grupo10mg.png
// module id = 94
// module chunks = 0